export const loadingSpinnerMessages = {
  ariaLabel: 'Loading',
} as const;
